import axios from "axios";

const getBaseUrl = () => {
  return (
    process.env.REACT_APP_CHAT_MICROSERVICE_URL ||
    "http://localhost:8000/api/v1"
  );
};

export const surveyWidgetService = {
  // Get active public surveys for widget
  getActiveSurveys: async (partnerId) => {
    if (!partnerId) return [];
    try {
      const response = await axios.get(
        `${getBaseUrl()}/surveys/public/active/${partnerId}`
      );
      return response.data?.data || response.data || [];
    } catch (err) {
      console.error("Error fetching active surveys for widget:", err);
      return [];
    }
  },

  // Check survey eligibility by email and rules
  checkEligibility: async (surveyId, email = "") => {
    if (!surveyId) return { shouldShow: false };
    try {
      const response = await axios.get(
        `${getBaseUrl()}/surveys/public/${surveyId}/eligibility`,
        { params: { email } }
      );
      return response.data?.data || response.data || { shouldShow: false };
    } catch (err) {
      console.error("Error checking survey eligibility:", err);
      return { shouldShow: false };
    }
  },

  // Submit survey response from widget
  submitResponse: async (surveyId, responsePayload) => {
    if (!surveyId) return null;
    try {
      const response = await axios.post(
        `${getBaseUrl()}/surveys/public/${surveyId}/responses`,
        responsePayload
      );
      return response.data?.data || response.data;
    } catch (err) {
      console.error("Error submitting survey response:", err);
      throw err;
    }
  },

  // Get active public chat messages for widget
  getActiveChatMessages: async (partnerId) => {
    if (!partnerId) return [];
    try {
      const response = await axios.get(
        `${getBaseUrl()}/chat-messages/public/active/${partnerId}`
      );
      return response.data?.data || response.data || [];
    } catch (err) {
      console.error("Error fetching active chat messages for widget:", err);
      return [];
    }
  },

  // Check chat message eligibility by email
  checkChatMessageEligibility: async (id, email = "") => {
    if (!id) return { shouldShow: false };
    try {
      const response = await axios.get(
        `${getBaseUrl()}/chat-messages/public/${id}/eligibility`,
        { params: { email } }
      );
      return response.data?.data || response.data || { shouldShow: false };
    } catch (err) {
      console.error("Error checking chat message eligibility:", err);
      return { shouldShow: false };
    }
  },

  // Submit chat message response/interaction from widget
  submitChatMessageResponse: async (id, payload) => {
    if (!id) return null;
    try {
      const response = await axios.post(
        `${getBaseUrl()}/chat-messages/public/${id}/responses`,
        payload
      );
      return response.data?.data || response.data;
    } catch (err) {
      console.error("Error submitting chat message response:", err);
      return null;
    }
  },

  // Get active public banners for widget
  getActiveBanners: async (partnerId) => {
    if (!partnerId) return [];
    try {
      const response = await axios.get(
        `${getBaseUrl()}/banners/public/active/${partnerId}`
      );
      return response.data?.data || response.data || [];
    } catch (err) {
      console.error("Error fetching active banners for widget:", err);
      return [];
    }
  },

  // Check banner eligibility by email
  checkBannerEligibility: async (id, email = "") => {
    if (!id) return { shouldShow: false };
    try {
      const response = await axios.get(
        `${getBaseUrl()}/banners/public/${id}/eligibility`,
        { params: { email } }
      );
      return response.data?.data || response.data || { shouldShow: false };
    } catch (err) {
      console.error("Error checking banner eligibility:", err);
      return { shouldShow: false };
    }
  },

  // Submit banner response/interaction from widget
  submitBannerResponse: async (id, payload) => {
    if (!id) return null;
    try {
      const response = await axios.post(
        `${getBaseUrl()}/banners/public/${id}/responses`,
        payload
      );
      return response.data?.data || response.data;
    } catch (err) {
      console.error("Error submitting banner response:", err);
      return null;
    }
  }
};
